import { connect } from 'react-redux';
import ForgotPassword from './ForgotPassword';
import { forgotPassword } from '../../actions/authActions';

export default connect(null, { forgotPassword })(ForgotPassword);
